import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Colors from "../../styles/colors";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface AlertModalProps {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
  title: string;
  description?: string;
  description2?: string;
  onPressButton1?: () => void;
  button1Label?: string;
  onPressButton2?: () => void;
  button2Label?: string;
}

const AlertModal = (props: AlertModalProps) => {
  const {
    isOpen,
    setIsOpen,
    title,
    description,
    description2,
    onPressButton1,
    button1Label,
    onPressButton2,
    button2Label,
  } = props;

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        // onClose={() => setIsOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={isOpen}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              {title}
            </Typography>
            {description ? (
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                {description}
              </Typography>
            ) : null}

            {description2 ? (
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                {description2}
              </Typography>
            ) : null}

            <Box className="buttons-container">
              {onPressButton1 ? (
                <Button
                  onClick={onPressButton1}
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    mt: 3,
                    backgroundColor: Colors.Highnote.blue4,
                    ":hover": {
                      backgroundColor: Colors.Highnote.blue3,
                      color: "white",
                    },
                  }}
                >
                  {button1Label}
                </Button>
              ) : null}

              {onPressButton2 ? (
                <Button
                  onClick={onPressButton2}
                  variant="contained"
                  size="large"
                  fullWidth
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: Colors.Highnote.blue4,
                    ":hover": {
                      backgroundColor: Colors.Highnote.blue3,
                      color: "white",
                    },
                  }}
                >
                  {button2Label}
                </Button>
              ) : null}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default AlertModal;
